import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendUltimaTareaCasoActivo,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Data from "../../../dataJson/ObtenerTareasAbiertasUsuario.json";
import mock_Json from "../../../dataJson/ObtenerTareasAbiertasUsuario.json";
import mock_CasosActivoPorId from "../../../dataJson/casosActivoPorId.json";
import { iDataStructure } from "../../../interfaces/backendApi/dataStruture";
import {
  formatDescripcion,
  formatearMensajeBackend,
  ordenarTareas,
  procesarPrioridades,
  shouldRenderTicket,
} from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";
import { formatearFechaCustom } from "../../../components/common/helper/formatoFecha";
import { iCasoActivo } from "../../../interfaces/bonita/casoActivo";
import { iListTaskHumanUserId } from "../../../interfaces/bonita/listTaskHumanUserId";
import { iClientesAdministrados } from "../../../interfaces/backendApi/clientesAdministrados";

interface State {
  ultimaTareaCasosActivosCliente: any[];
  itemAllContratosAdministrados: any[]; //aca
  itemAll: any[];
  status: TypeStatus;
  isLoading: boolean;
  idContrato: string;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  ultimaTareaCasosActivosCliente: [],
  itemAllContratosAdministrados: [], //aca
  status: "idle",
  isLoading: false,
  idContrato: "",
  error: null,
  itemAll: [],
  Success: false,
  Mensaje: null,
};

interface defaultResponse {
  data: iDataStructure;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
  data: {
    Success: false,
    Mensaje: "",
    Data: [],
  },
};
const ultimaTareaCasosActivosClienteSlice = createSlice({
  name: "ultimaTareaCasosActivosCliente",
  initialState,
  reducers: {
    setUltimaTareaCasosActivosCliente: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state.ultimaTareaCasosActivosCliente = action.payload;
    },
    setItemAllContratosAdministrados: (state, action: PayloadAction<any[]>) => {
      state.itemAllContratosAdministrados = action.payload;
    },
    setItemAll: (state, action: PayloadAction<any[]>) => {
      state.itemAll = action.payload;
    },
    getUltimaTareaCasosActivosCliente: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state.ultimaTareaCasosActivosCliente = action.payload;
    },
    setIdContrato: (state, action: PayloadAction<string>) => {
      state.idContrato = action.payload;
    },
    setClearUltimaTareaCasosActivosCliente: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
  },
});
const procesarTareasAbiertasPorIdUsuario = async (
  Tareas: any[],
  Casos: any[],
) => {
  return await Promise.all(
    Tareas.map(async (tarea) => {
      const {
        priority,
        alarma,
        descripcion,
        ticketRedmine,
        ci,
        responsable: iresponsable,
      } = tarea;
      let partesResumen = [];
      let elresponsable = [];
      if (iresponsable) {
        elresponsable.push(`${" aca responsable " + iresponsable}`);
      }
      if (priority) {
        partesResumen.push(`Prioridad: ${priority}`);
      }
      if (alarma) {
        partesResumen.push(`Titulo: ${alarma}`);
      }
      if (descripcion) {
        const value = formatDescripcion(descripcion);
        partesResumen.push(`Descripción: ${value}`);
      }
      if (ci) {
        partesResumen.push(`Ci: ${ci}`);
      }

      const renderTicketRedmine = shouldRenderTicket(ticketRedmine);

      if (renderTicketRedmine) {
        partesResumen.push(`Ticket Redmine Nro: ${ticketRedmine}`);
      }
      const resumen =
        partesResumen.length > 0
          ? partesResumen.join("\n\n")
          : "No pudimos obtener los datos del caso";

      Tareas.forEach((tarea: iListTaskHumanUserId) => {
        // Busca si hay algún caso con el mismo caseId que la tarea actual
        const casoCorrespondiente = Casos.find(
          (caso: any) => Number(caso.Caso) === Number(tarea.caseId),
        );
        // Si se encuentra un caso correspondiente, asigna su responsable a la tarea
        if (casoCorrespondiente) {
          tarea.responsable = casoCorrespondiente.UsuarioSolicitante; // Aquí debes poner el campo correspondiente
        } else {
          tarea.responsable = "No hay responsable";
        }
      });

      return {
        ...tarea,
        resumen,
        // responsable,
      };
    }),
  );
};

export const setBackendListaTareasAbiertasPorIdUsuario =
  (
    UsuarioBonitaRM: number,
    cliente_id: number,
    clientesAdministrados: iClientesAdministrados[],
    Cantidad: number,
    NumPagina: number,
  ): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      let arrayResponseData: iListTaskHumanUserId[] = [];
      let arrayCasosActivoPorId: iCasoActivo[] = [];
      const clientePorId = clientesAdministrados.filter(
        (item) =>
          item.IdCliente === Number(cliente_id) ||
          item.IdCliente === Number(UsuarioBonitaRM),
      );

      dispatch(setIsLoading(true));
      let response: AxiosResponse = defaultResp;
      let response2: AxiosResponse = defaultResp;
      try {
        if (clientePorId.length > 0) {
          for (const obj of clientePorId) {
            for (const id of obj.UsuariosBonita) {
              if (Number(id) > 0) {
                //response = await BackendUltimaTareaCasoActivo(0, id);
                //arrayResponseData =
                //  [...arrayResponseData, ...response.data.Data];
                try {
                  response = await BackendUltimaTareaCasoActivo(0, id);
                  if (response.data?.Data) {
                    arrayResponseData = [
                      ...arrayResponseData,
                      ...response.data.Data,
                    ];
                  }
                } catch (e) {
                  console.warn(`Error consultando el  ${id}:`, e);
                }
              }
            }
          }
        }

        if (arrayResponseData.length > 0) {
          for (const obj of arrayResponseData) {
            if (Number(obj.caseId) > 0) {
              response2 = await BackendUltimaTareaCasoActivo(
                Number(obj.caseId),
                Number(obj.caseId),
              );
              arrayCasosActivoPorId = [
                ...arrayCasosActivoPorId,
                ...response2.data.Data,
              ];
            }
          }
        }

        arrayResponseData.forEach((tarea: iListTaskHumanUserId) => {
          // Busca si hay algún caso con el mismo caseId que la tarea actual
          const casoCorrespondiente = arrayCasosActivoPorId.find(
            (caso: iCasoActivo) => caso.id === tarea.caseId,
          );
          // Si se encuentra un caso correspondiente, asigna su responsable a la tarea
          if (casoCorrespondiente) {
            tarea.responsable = casoCorrespondiente.Usuario; // Aquí debes poner el campo correspondiente
          } else {
            tarea.responsable = "No hay responsable";
          }
        });

        let ordenarLista = [...arrayResponseData];
        ordenarLista = procesarPrioridades(ordenarLista);
        ordenarLista.sort(ordenarTareas);
        ordenarLista = ordenarLista.map((e) => ({
          ...e,
          assigned_date: formatearFechaCustom(e.assigned_date),
          dueDate: formatearFechaCustom(e.dueDate),
          reached_state_date: formatearFechaCustom(e.reached_state_date),
          last_update_date: formatearFechaCustom(e.last_update_date), // Genera un nuevo objeto con la fecha formateada
        }));

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let listaFormateada = await procesarTareasAbiertasPorIdUsuario(
            ordenarLista,
            arrayCasosActivoPorId,
          );
          dispatch(setUltimaTareaCasosActivosCliente(listaFormateada));
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }

        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));
        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          dispatch(setStatus("succeeded"));
          let arrayResponseData: any[] = mock_Json.Data;
          let arrayCasosActivoPorId: any[] = mock_CasosActivoPorId.Data;
          let response: AxiosResponse = defaultResp;
          response.data = mock_Json;
          if (clientePorId.length > 0) {
            for (const obj of clientePorId) {
              for (const id of obj.UsuariosBonita) {
                if (Number(id) > 0) {
                  const responsable = mock_CasosActivoPorId.Data[0].Usuario;

                  response.data.Data = response.data.Data.map((item: any) => {
                    return {
                      ...item,
                      responsable: responsable,
                    };
                  });
                  let responseData = response.data.Data[0];
                  let modifiedResponseData = { ...responseData }; // Clonar el objeto original
                  modifiedResponseData.responsable = responsable; // Agregar la nueva propiedad
                  dispatch(setSuccess(response.data.Success));
                  dispatch(
                    setMensaje(formatearMensajeBackend(response.data.Mensaje)),
                  );
                  arrayResponseData = [
                    ...arrayResponseData,
                    [modifiedResponseData],
                  ];
                  arrayResponseData = response.data.Data;
                }
              }
            }
          }

          arrayResponseData.forEach((tarea: iListTaskHumanUserId) => {
            // Busca si hay algún caso con el mismo caseId que la tarea actual
            const casoCorrespondiente = arrayCasosActivoPorId.find(
              (caso: iCasoActivo) => caso.id === tarea.caseId,
            );
            // Si se encuentra un caso correspondiente, asigna su responsable a la tarea
            if (casoCorrespondiente) {
              tarea.responsable = casoCorrespondiente.Usuario; // Aquí debes poner el campo correspondiente
            } else {
              tarea.responsable = "no hay responsable";
            }
          });

          let ordenarLista = [...arrayResponseData];
          ordenarLista.sort(ordenarTareas);

          ordenarLista = procesarPrioridades(ordenarLista);
          ordenarLista = ordenarLista.map(
            (e: {
              archivedDate: string;
              reached_state_date: string;
              last_update_date: string;
              assigned_date: string;
              dueDate: string;
            }) => ({
              ...e,
              assigned_date: formatearFechaCustom(e.assigned_date),
              dueDate: formatearFechaCustom(e.dueDate),
              archivedDate: formatearFechaCustom(e.archivedDate),
              reached_state_date: formatearFechaCustom(e.reached_state_date),
              last_update_date: formatearFechaCustom(e.last_update_date), // Genera un nuevo objeto con la fecha formateada
            }),
          );
          ordenarLista = ordenarLista.map((e) => ({
            ...e,
            assigned_date: formatearFechaCustom(e.assigned_date),
            dueDate: formatearFechaCustom(e.dueDate),
            reached_state_date: formatearFechaCustom(e.reached_state_date),
            last_update_date: formatearFechaCustom(e.last_update_date), // Genera un nuevo objeto con la fecha formateada
          }));

          const mockData: any = mock_Json;
          const isErrorMock =
            mockData?.Success === false ||
            (mockData?.ResultadoSolicitud !== undefined &&
              mockData?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
          } else {
            let listaFormateada = await procesarTareasAbiertasPorIdUsuario(
              ordenarLista,
              arrayCasosActivoPorId,
            );
            dispatch(setUltimaTareaCasosActivosCliente(listaFormateada));
            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));
          }
          return response.data;
        }
      }
    };

export const setBackendUltimaTareaCasosActivosCliente =
  (IdCliente: number, caseId: number, casos: any[]): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      try {
        let allData: any[] = [];
        let response: AxiosResponse = defaultResp;
        for (const iCaso of casos) {
          if (iCaso.Caso) {
            const { Caso } = iCaso;
            try {
              response = await BackendUltimaTareaCasoActivo(IdCliente, Caso);
              if (response.data?.Data) {
                allData = [...allData, ...response.data.Data];
              }
            } catch (e) {
              console.warn(`Error consultando el caso ${Caso}:`, e);
            }
          }
        }
        let ordenarLista = [...allData];
        ordenarLista = procesarPrioridades(ordenarLista);
        ordenarLista.sort(ordenarTareas);
        ordenarLista = ordenarLista.map((e) => ({
          ...e,
          assigned_date: formatearFechaCustom(e.assigned_date),
          dueDate: formatearFechaCustom(e.dueDate),
          reached_state_date: formatearFechaCustom(e.reached_state_date),
          last_update_date: formatearFechaCustom(e.last_update_date), // Genera un nuevo objeto con la fecha formateada
        }));

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let listaFormateada = await procesarTareasAbiertasPorIdUsuario(
            ordenarLista,
            casos,
          );
          dispatch(setUltimaTareaCasosActivosCliente(listaFormateada));
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }

        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));
        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          let allData: any[] = [];
          let response: AxiosResponse = defaultResp;
          for (const iCaso of casos) {
            if (iCaso.Caso) {
              allData = [...allData, ...mock_Data.Data];
            }
          }
          let ordenarLista = [...allData];
          ordenarLista = procesarPrioridades(ordenarLista);
          ordenarLista.sort(ordenarTareas);
          ordenarLista = ordenarLista.map((e) => ({
            ...e,
            assigned_date: formatearFechaCustom(e.assigned_date),
            dueDate: formatearFechaCustom(e.dueDate),
            reached_state_date: formatearFechaCustom(e.reached_state_date),
            last_update_date: formatearFechaCustom(e.last_update_date), // Genera un nuevo objeto con la fecha formateada
          }));

          const mockData: any = mock_Data;
          const isErrorMock =
            mockData?.Success === false ||
            (mockData?.ResultadoSolicitud !== undefined &&
              mockData?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
          } else {
            let listaFormateada = await procesarTareasAbiertasPorIdUsuario(
              ordenarLista,
              casos,
            );
            dispatch(setUltimaTareaCasosActivosCliente(listaFormateada));
            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));
          }
          return response.data;
        }
      }
    };

export const setBackendClearUltimaTareaCasosActivosCliente =
  (): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      try {
        let response: AxiosResponse = defaultResp;
        dispatch(setUltimaTareaCasosActivosCliente([]));
        dispatch(setItemAllContratosAdministrados([]));
        dispatch(setIsLoading(false));
        dispatch(setStatus("idle"));
        dispatch(setSuccess(false));
        dispatch(setMensaje(""));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("idle"));
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
      }
    };

export const {
  setUltimaTareaCasosActivosCliente,
  setItemAllContratosAdministrados,
  setItemAll,
  getUltimaTareaCasosActivosCliente,
  setIdContrato,
  setClearUltimaTareaCasosActivosCliente,
  setIsLoading,
  setStatus,
  setResult,
  setMensaje,
  setSuccess,
} = ultimaTareaCasosActivosClienteSlice.actions;

export default ultimaTareaCasosActivosClienteSlice.reducer;
